import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AlertTriangle, Clock, CreditCard } from 'lucide-react';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BillingBanner = () => {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/billing/status`).then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  if (!status || status.is_grandfathered) return null;

  const s = status.subscription_status;
  let content = null;

  if (s === 'past_due') {
    content = {
      cls: 'bg-red-600',
      icon: AlertTriangle,
      text: 'Your last payment failed. Update your payment method to keep full access.',
      cta: 'Fix payment',
    };
  } else if (s === 'canceled') {
    content = {
      cls: 'bg-gray-800',
      icon: AlertTriangle,
      text: 'Your subscription is canceled. Reactivate to keep using ShelterConnectOS.',
      cta: 'Reactivate',
    };
  } else if (s === 'trialing' && !status.has_payment_method) {
    const d = status.trial_days_left;
    content = {
      cls: d != null && d <= 5 ? 'bg-amber-600' : 'bg-indigo-600',
      icon: Clock,
      text: `You're on a free trial${d != null ? ` — ${Math.max(0, d)} day${d === 1 ? '' : 's'} left` : ''}. Add a payment method so your service continues uninterrupted.`,
      cta: 'Add payment method',
    };
  }

  if (!content) return null;
  const Icon = content.icon;

  return (
    <div className={`${content.cls} text-white`} data-testid="billing-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm">
          <Icon className="h-4 w-4 shrink-0" />
          <span>{content.text}</span>
        </div>
        <Button size="sm" variant="secondary" className="bg-white text-gray-900 hover:bg-gray-100" onClick={() => navigate('/billing')} data-testid="billing-banner-cta">
          <CreditCard className="h-4 w-4 mr-1" /> {content.cta}
        </Button>
      </div>
    </div>
  );
};

export default BillingBanner;
